import {
  Button,
  Flex,
  
  FormControl,
  FormLabel,
  Grid,
  Input,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useState } from "react";

import axios from "axios";
import AdminLogin from "../AdminNav/Login";

import { PageHeader } from "../../components/ui";
import { API_URL } from "../../Apis/config";

export default function Expense({ onSearch }) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState({
    "transaction": 0,
    "paid": 0,
    "unpaid": 0,
    "expense": 0,
    "net": 0,
    "event": 0,
    "eventUnpaid": 0,
    "netEvent": 0,
    "astro": 0,
    "astrounpaid": 0,
    "netAstro": 0,
    "kashi": 0,
    "kashiUnpaid": 0,
    "netKashi": 0,
    "kashiExpense": 0,
    
    });

  const handleFromDateChange = (event) => {
    const [year, month, day] = event.target.value.split("-");
    const formattedDate = `${day}/${month}/${year}`;
    setFromDate(formattedDate);
  };

  const handleToDateChange = (event) => {
    const [year, month, day] = event.target.value.split("-");
    const formattedDate = `${day}/${month}/${year}`;
    setToDate(formattedDate);
  };

  const handleSearch = () => {
    axios
      .get(
        `${API_URL}/revenue?from=${fromDate}&to=${toDate}`
      )
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  };
  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  // The API never fills astrounpaid or netAstro, but its unpaid total is events plus astro.
  const astroUnpaid = data.unpaid - data.eventUnpaid;
  const netAstro = data.astro + astroUnpaid;
  return (
    <>
      <PageHeader title="Revenue" subtitle="Income and expense for a date range" />
      <Flex gap={3} align="flex-end" wrap="wrap" mb={5}>
        <FormControl w={{ base: "100%", md: "200px" }}>
          <FormLabel>From</FormLabel>
          <Input type="date" name="from" onChange={handleFromDateChange} />
        </FormControl>
        <FormControl w={{ base: "100%", md: "200px" }}>
          <FormLabel>To</FormLabel>
          <Input type="date" name="to" onChange={handleToDateChange} />
        </FormControl>
        <Button onClick={handleSearch}>Search</Button>
      </Flex>
      {data && (
        <TableContainer borderRadius="lg" border="1px solid" borderColor="stone.200">
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Details</Th>
                <Th>Astro</Th>
                <Th>Events</Th>
                <Th>Total</Th>
                <Th>Kashiyatra</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>Transaction</Td>
                <Td>{data.astro + astroUnpaid}</Td>
                <Td>{data.event + data.eventUnpaid}</Td>
                <Td>{data.transaction}</Td>
                <Td>{data.kashi+data.kashiUnpaid}</Td>
              </Tr>
              <Tr>
                <Td>Paid</Td>
                <Td>{data.astro}</Td>
                <Td>{data.event}</Td>
                <Td>{data.paid}</Td>
                <Td>{data.kashi}</Td>
              </Tr>
              <Tr>
                <Td>Remaining</Td>
                <Td>{astroUnpaid}</Td>
                <Td>{data.eventUnpaid}</Td>
                <Td>{data.unpaid}</Td>
                <Td>{data.kashiUnpaid}</Td>
              </Tr>
              <Tr>
                <Td>Expense</Td>
                <Td>0</Td>
                <Td>{data.expense}</Td>
                <Td>{data.expense}</Td>
                <Td>{data.kashiExpense}</Td>
              </Tr>
              <Tr>
                <Td fontWeight={600}>Net income</Td>
                <Td>{netAstro}</Td>
                <Td>{data.netEvent}</Td>
                <Td>{data.net}</Td>
                <Td>{data.netKashi}</Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
